import { AfterContentChecked, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatStepper } from '@angular/material/stepper';
import {
  CONTACT_DATA,
  DIRECT_DEBIT,
  FINANCE,
  FORM_MG,
  HOLDER_DATA,
  INSURANCE,
  POINT_OF_SALE,
  PRESCRIBER_CONTACT_DATA,
  REQUEST_DATA,
  REQUEST_DATA_MG,
  REQUEST_MODE_NEW,
  REQUEST_OBSERVATIONS,
  REQUEST_STEPPER_1,
  REQUEST_STEPPER_2,
  REQUEST_STEPPER_3,
  SOCIOECONOMIC_DATA,
} from '@app/@core/constants/requests.constants';
import { PrintStore } from '@app/@shared';
import { CustomValidatorsService } from '@app/@shared/custom-validators/custom-validators.service';
import { PaswordDialogComponent } from '@app/@shared/dialogs/password/password-dialog.component';
import { ResponseDialogComponent } from '@app/@shared/dialogs/response/response-dialog.component';
import { LoaderGenericService } from '@app/@shared/loader-generic/loader-generic.service';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { CombosStore } from '../combos-service/combos.store';
import { CommonDataDTO } from '../model/combos-model';
import { RequestsSaveSendStore } from '../requests-save-send-service/requests-save-send.store';
import { CalculatorResponseDTO, RequestFormDTO } from './../model/requests-model';

@Component({
  selector: 'app-request-mg',
  templateUrl: './request-mg.component.html',
  styleUrls: ['./request-mg.component.scss'],
})
export class RequestMgComponent implements OnInit, AfterContentChecked {
  public establishmentToSend: string;
  public vendorToSend: CommonDataDTO;
  public financingDtoToSend: CalculatorResponseDTO[];
  public enviarPeticion: boolean;
  public guardarPeticion: boolean;
  @Input() mode: string = 'new';
  @Input() request: any = null;
  @Input() state: CommonDataDTO;
  @Output() establishment = new EventEmitter<CommonDataDTO>();
  @Output() public isFinishedLoading = new EventEmitter<boolean>();

  changingValueClearTable: Subject<boolean> = new Subject();

  public isFirstStepCompleted: boolean;
  public isSecondStepCompleted: boolean;
  public isThirdStepCompleted: boolean;
  public numOperation: string = '';

  firstStepError: boolean = false;
  secondStepError: boolean = false;
  thirdStepError: boolean = false;

  //Loading
  private isPointOfSaleLoaded: boolean = false;
  private isRequestDataLoaded: boolean = false;
  private isRequestDataCardLoaded: boolean = false;
  private isFinanceLoaded: boolean = false;
  private isBasicContactLoaded: boolean = false;
  private isHolderLoaded: boolean = false;
  private isContactLoaded: boolean = false;
  private isSocioeconomicLoaded: boolean = false;
  private isDirectDebitLoaded: boolean = false;
  private isObservationsLoaded: boolean = false;
  private isPrescriberDataLoaded: boolean = false;

  constructor(
    private requestsStore: RequestsSaveSendStore,
    public dialog: MatDialog,
    private cdref: ChangeDetectorRef,
    private translate: TranslateService,
    private combosStore: CombosStore,
    private printStore: PrintStore,
    private customValidatorsService: CustomValidatorsService
  ) {}

  ngAfterContentChecked(): void {
    this.cdref.detectChanges();
  }

  ngOnDestroy(): void {
    this.clearTest();
  }

  public ngOnInit() {
    this.requestsStore.enviarPeticion$.subscribe((valor: boolean) => {
      this.enviarPeticion = valor;
    });

    this.requestsStore.firstStepSource$.subscribe((valor: boolean) => {
      this.isFirstStepCompleted = valor;
      this.changeErrorStateEditView(REQUEST_STEPPER_1);
    });

    this.requestsStore.secondStepSource$.subscribe((valor: boolean) => {
      this.isSecondStepCompleted = valor;
      this.changeErrorStateEditView(REQUEST_STEPPER_2);
    });

    this.requestsStore.thirdStepSource$.subscribe((valor: boolean) => {
      this.isThirdStepCompleted = valor;
      this.changeErrorStateEditView(REQUEST_STEPPER_3);
    });

    if (this.mode != REQUEST_MODE_NEW) {
      this.numOperation = this.request.numOperation;
    }

    this.requestsStore.setMarcaFormulario(FORM_MG);
    this.combosStore.setBrandRequest(FORM_MG);
    this.combosStore.setLanguageRequest('ES');
  }

  public changeContinueStatusForms(formMg: any) {
    this.requestsStore.listaFormulariosMg[formMg.id] = formMg.form;
    this.updateDisabledSendButton();
    this.updateSteps();
  }

  public updateDisabledSendButton() {
    //TODO: En la próxima minor release a la 13.0.2. de la líbreria Angular, la property Status pasará de ser String a FormControlStatus
    //Change - https://github.com/angular/angular/pull/42952
    //Issue - https://github.com/angular/angular/issues/44176
    const isInvalid = this.requestsStore.listaFormulariosMg.findIndex((form) => form?.status === 'INVALID');
    if (isInvalid >= 0) {
      this.requestsStore.setEnviarPeticion(false);
    } else {
      this.requestsStore.setEnviarPeticion(true);
    }
  }

  public updateSteps(): void {
    const firstStepForms = [POINT_OF_SALE, PRESCRIBER_CONTACT_DATA, REQUEST_DATA, FINANCE];
    const secondStepForms = [HOLDER_DATA, CONTACT_DATA, SOCIOECONOMIC_DATA];
    const thirdStepForms = [DIRECT_DEBIT, REQUEST_OBSERVATIONS];
    this.updateStepsControl(firstStepForms)
      ? this.requestsStore.setFirstStep(true)
      : this.requestsStore.setFirstStep(false);
    this.updateStepsControl(secondStepForms)
      ? this.requestsStore.setSecondStep(true)
      : this.requestsStore.setSecondStep(false);
    this.updateStepsControl(thirdStepForms)
      ? this.requestsStore.setThirdStep(true)
      : this.requestsStore.setThirdStep(false);
  }

  public updateStepsControl(formIndex: number[]): boolean {
    let forms: FormGroup[] = [];
    for (let index of formIndex) {
      forms.push(this.requestsStore.listaFormulariosMg[index]);
    }
    return forms.findIndex((form) => form?.status === 'INVALID') >= 0 ? false : true;
  }

  openDialogPassword(type: string) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '90%';
    dialogConfig.maxWidth = '550px';

    let invalidFields: string[] = [];
    invalidFields = this.fieldsRequired(type);

    if (invalidFields.length === 0) {
      let request_type: string;
      request_type = FORM_MG;
      dialogConfig.data = { type: type, request_type: request_type, request: this.request, mode: this.mode };
      const passwordDialog = this.dialog.open(PaswordDialogComponent, dialogConfig);

      passwordDialog.afterClosed().subscribe((dataDialogPass: any) => {
        if (dataDialogPass?.password) {
          if (type === 'print') {
            this.requestsStore.printRequest(request_type, dataDialogPass, this.numOperation);
          } else {
            if (this.customValidatorsService.checkNoEmailNoPhone(0, this.requestsStore.listaFormulariosMg)) {
              if (this.requestsStore.listaFormulariosMg[INSURANCE].value.insuranceSelect === 'S' && type === 'send') {
                this.requestsStore.getTestRequest(type, request_type, dataDialogPass, this.numOperation);
              } else {
                this.requestsStore.saveAndSend(type, request_type, dataDialogPass, this.numOperation);
              }
            } else {
              //show dialog noemail
              dialogConfig.data = {
                title: this.translate.instant('dialog.noemail.title'),
                text: this.translate.instant('dialog.noemail.signature.text'),
                icon: 'icon-ic_warning',
                buttonCancel: true,
              };
              const dialogNoEmail = this.dialog.open(ResponseDialogComponent, dialogConfig);
              dialogNoEmail.afterClosed().subscribe((accept: boolean) => {
                console.log('accept: ', accept);
                if (accept) {
                  this.requestsStore.saveAndSend(type, request_type, dataDialogPass, this.numOperation);
                }
              });
            }
          }
        }
      });
    } else {
      let text = invalidFields.join(' , ');
      dialogConfig.data = { text: this.translate.instant('dialog.fieldRequired') + text, icon: 'icon-ic_warning' };
      this.dialog.open(ResponseDialogComponent, dialogConfig);
    }
  }

  setEstablishment(establishment: string) {
    this.establishmentToSend = establishment;
  }

  setVendor(vendor: CommonDataDTO) {
    this.vendorToSend = vendor;
  }

  sendFinanceData(financingDtoList: CalculatorResponseDTO[]) {
    this.financingDtoToSend = financingDtoList;
  }

  public tellChildClearTable() {
    this.changingValueClearTable.next(false);
  }

  public clearFields() {
    this.requestsStore.resetForms(FORM_MG);
    this.tellChildClearTable();
    this.clearTest();
  }

  public saveAndExit() {
    console.log(this.requestsStore.listaFormulariosMg);
    //this.requestsStore.saveRequest(FORM_MG);
  }

  public SendRequest() {
    //this.requestsStore.sendRequest(FORM_MG);
  }

  public fieldsRequired(type: string): string[] {
    if (type === 'print') {
      return this.fieldsRequiredPrint();
    } else {
      return this.fieldsRequiredSave();
    }
  }

  public fieldsRequiredSave(): string[] {
    let invalidFields: string[] = [];
    this.requestsStore.listaFormulariosMg.forEach((form, index) => {
      for (const name in form.controls) {
        if (form.controls[name].invalid) {
          switch (name) {
            case 'establishment':
              invalidFields.push(this.translate.instant('pointOfSale.establishment'));
              break;
            case 'vendor':
              invalidFields.push(this.translate.instant('pointOfSale.vendor'));
              break;
            case 'requestLanguage':
              invalidFields.push(this.translate.instant('pointOfSale.requestLanguage'));
              break;
            case 'requestDate':
              invalidFields.push(this.translate.instant('pointOfSale.requestDate'));
              break;
            case 'nifNie':
              invalidFields.push(this.translate.instant('holderData.nifNie'));
              break;
            case 'nifNieExpiration':
              invalidFields.push(this.translate.instant('holderData.nifNieExpiration'));
              break;
            case 'name':
              invalidFields.push(this.translate.instant('holderData.name'));
              break;
            case 'surname1':
              invalidFields.push(this.translate.instant('holderData.surname1'));
              break;
            case 'surname2':
              invalidFields.push(this.translate.instant('holderData.surname2'));
              break;
          }
        }
      }
    });
    return invalidFields;
  }

  public fieldsRequiredPrint(): string[] {
    let invalidFields: string[] = [];
    this.requestsStore.listaFormulariosMg.forEach((form, index) => {
      for (const name in form.controls) {
        if (form.controls[name].invalid) {
          switch (name) {
            case 'establishment':
              invalidFields.push(this.translate.instant('pointOfSale.establishment'));
              break;
            case 'vendor':
              invalidFields.push(this.translate.instant('pointOfSale.vendor'));
              break;
            case 'requestLanguage':
              invalidFields.push(this.translate.instant('pointOfSale.requestLanguage'));
              break;
            case 'requestDate':
              invalidFields.push(this.translate.instant('pointOfSale.requestDate'));
              break;
            case 'nifNie':
              invalidFields.push(this.translate.instant('holderData.nifNie'));
              break;
            case 'nifNieExpiration':
              invalidFields.push(this.translate.instant('holderData.nifNieExpiration'));
              break;
            case 'name':
              invalidFields.push(this.translate.instant('holderData.name'));
              break;
            case 'surname1':
              invalidFields.push(this.translate.instant('holderData.surname1'));
              break;
            case 'surname2':
              invalidFields.push(this.translate.instant('holderData.surname2'));
              break;
            case 'birthDate':
              invalidFields.push(this.translate.instant('holderData.birthDate'));
              break;
            case 'commercialProduct':
              invalidFields.push(this.translate.instant('request.commercialProduct'));
              break;
            case 'lineProduct':
              invalidFields.push(this.translate.instant('request.lineProduct'));
              break;
            case 'product':
              invalidFields.push(this.translate.instant('request.product'));
              break;
            case 'priceProduct':
              invalidFields.push(this.translate.instant('requestedAmount'));
              break;
            case 'requestedAmount':
              invalidFields.push(this.translate.instant('request.requestedAmount'));
              break;
            case 'term':
              invalidFields.push(this.translate.instant('request.term'));
              break;
            case 'tariffs':
              invalidFields.push(this.translate.instant('request.tariffs'));
              break;
            // campos obligatorios imprimir
            case 'laboralSituation':
              invalidFields.push(this.translate.instant('socioeconimicData.laboralSituation'));
              break;
            case 'ownershipCombo':
              invalidFields.push(this.translate.instant('request.ownershipLabel'));
              break;
            case 'numberCreditAccount':
              invalidFields.push(this.translate.instant('request.bankAccount'));
              break;
            case 'expirationDay':
              invalidFields.push(this.translate.instant('requestDataCard.firstDayExpiration'));
              break;
            case 'modality':
              invalidFields.push(this.translate.instant('requestDataCard.cardModality'));
              break;
            case 'amountCard':
              invalidFields.push(this.translate.instant('requestDataCard.selectAmount'));
              break;
          }
        }
      }
    });
    return invalidFields;
  }

  private clearTest(): void {
    this.requestsStore.numOperation = '';
    this.requestsStore.optionTest = false;
    this.requestsStore.optionTestAccept = '';
  }

  public changeContinueLoadingStatus(loadingState: any) {
    const formID = loadingState.formID;
    const value = loadingState.value;
    switch (formID) {
      case POINT_OF_SALE:
        this.isPointOfSaleLoaded = value;
        break;
      case REQUEST_DATA:
        this.isRequestDataLoaded = value;
        break;
      case REQUEST_DATA_MG:
        this.isRequestDataCardLoaded = value;
      case FINANCE:
        this.isFinanceLoaded = value;
        break;
      case HOLDER_DATA:
        this.isHolderLoaded = value;
        break;
      case CONTACT_DATA:
        this.isContactLoaded = value;
        break;
      case SOCIOECONOMIC_DATA:
        this.isSocioeconomicLoaded = value;
        break;
      case DIRECT_DEBIT:
        this.isDirectDebitLoaded = value;
        break;
      case REQUEST_OBSERVATIONS:
        this.isObservationsLoaded = value;
        break;
      case PRESCRIBER_CONTACT_DATA:
        this.isPrescriberDataLoaded = value;
        break;
      default:
        console.error('No se ha encontrado el formulario');
    }
    this.triggerStopLoader();
  }

  private triggerStopLoader(): void {
    if (
      this.isPointOfSaleLoaded &&
      this.isRequestDataCardLoaded &&
      this.isRequestDataLoaded &&
      this.isFinanceLoaded &&
      this.isHolderLoaded &&
      this.isContactLoaded &&
      this.isSocioeconomicLoaded &&
      this.isDirectDebitLoaded &&
      this.isObservationsLoaded &&
      this.isPrescriberDataLoaded
    ) {
      this.isFinishedLoading.emit(true);
    } else {
      this.isFinishedLoading.emit(false);
    }
  }

  private changeErrorStateGeneric(reference: number) {
    switch (reference) {
      case REQUEST_STEPPER_1:
        this.firstStepError = !this.isFirstStepCompleted;
        break;
      case REQUEST_STEPPER_2:
        this.secondStepError = !this.isSecondStepCompleted;
        break;
      case REQUEST_STEPPER_3:
        this.thirdStepError = !this.isThirdStepCompleted;
        break;
      default:
        console.error('changeErrorState: Reference not found');
    }
  }

  //This is new
  changeStepper(event: any, stepper: MatStepper) {
    stepper.steps.forEach((step, index) => {
      if (step.interacted) this.changeErrorStateGeneric(index);
    });
  }

  private changeErrorStateEditView(reference: number) {
    if (this.mode !== REQUEST_MODE_NEW) {
      this.changeErrorStateGeneric(reference);
    }
  }
}
